var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 134c-8-8-12-19-12-31s4-23 12-30c8-8 19-13 31-13s23 5 30 12l1 1c8 7 13 18 13 30s-5 23-13 31-19 13-31 13-23-5-31-13zm323 50V42c0-11-4-22-12-30-8-7-18-12-30-12H42C31 0 20 5 12 12 5 20 0 31 0 42v322c0 12 5 22 12 30 8 8 19 12 30 12h322c12 0 22-4 30-12s12-18 12-30V184zM223 17h141c7 0 13 3 18 7 5 5 7 11 7 18v232l-89-90c-7-7-12-10-19-10s-12 3-19 10l-85 85-59-59c-7-7-12-10-19-10-6 0-12 3-19 10l-39 39c-3 3-3 9 0 12 4 3 9 3 12 0l39-39c4-4 6-5 7-5s4 1 7 5l64 64 1 1 2 2 24 24c3 3 9 3 12 0 4-3 4-9 0-12l-20-20 85-85c4-3 6-5 7-5s3 2 7 5l101 102v66c0 7-2 13-7 18s-11 7-18 7H42c-7 0-13-2-18-7-4-5-7-11-7-18V42c0-7 3-13 7-18 5-4 11-7 18-7h181zM88 103c0 8 3 14 7 19 5 5 12 8 19 8s14-3 19-8 8-11 8-19c0-7-3-14-8-18l-1-1c-4-4-11-7-18-7s-14 3-19 8c-4 4-7 11-7 18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.6bc4ba39ca1132a24141394d8c150f2d.svg";
export { ForwardRef as ReactComponent };